(() => {
  const ROOT_SELECTOR = '[data-regista-loox-random-grid]';
  const INITIALIZED_ATTRIBUTE = 'data-regista-randomized';
  const MAX_ATTEMPTS = 28;
  const ATTEMPT_DELAY = 250;

  const randomInt = (max) => {
    if (max <= 0) return 0;

    if (window.crypto && window.crypto.getRandomValues) {
      const values = new Uint32Array(1);
      window.crypto.getRandomValues(values);
      return values[0] % max;
    }

    return Math.floor(Math.random() * max);
  };

  const shuffle = (items) => {
    const result = [...items];

    for (let index = result.length - 1; index > 0; index -= 1) {
      const swapIndex = randomInt(index + 1);
      [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
    }

    return result;
  };

  const findVisualReviewCards = (root) => {
    const selectors = [
      '[data-review-id]',
      '[data-review_id]',
      '.loox-review-card',
      '.loox-review',
      '.review-item',
      '.grid-item'
    ];

    for (const selector of selectors) {
      const candidates = [...root.querySelectorAll(selector)].filter((element) => {
        if (!element.querySelector('img, video, picture')) return false;
        return !element.parentElement?.closest(selector);
      });

      if (candidates.length >= 2) return candidates;
    }

    return [];
  };

  const randomizeGrid = (root, attempt = 0) => {
    if (!root || root.hasAttribute(INITIALIZED_ATTRIBUTE)) return;

    const searchableRoots = [root];
    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) searchableRoots.push(element.shadowRoot);
    });

    for (const searchableRoot of searchableRoots) {
      const cards = findVisualReviewCards(searchableRoot);
      if (cards.length < 2) continue;

      const parent = cards[0].parentElement;
      if (!parent || cards.some((card) => card.parentElement !== parent)) continue;

      shuffle(cards).forEach((card) => parent.appendChild(card));
      root.setAttribute(INITIALIZED_ATTRIBUTE, 'true');
      return;
    }

    if (attempt < MAX_ATTEMPTS) {
      window.setTimeout(() => randomizeGrid(root, attempt + 1), ATTEMPT_DELAY);
    }
  };

  const initializeRoot = (root) => {
    if (root instanceof Element) randomizeGrid(root);
  };

  const initializeAll = () => {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(ROOT_SELECTOR)) initializeRoot(node);
        node.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
